<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 14:13:45
 * @LastEditTime: 2020-09-15 16:02:49
 * @Description: 年份筛选条件
 -->
<template>
  <div class="year-filter">
    <i-checkbox
      class="title"
      :indeterminate="indeterminate"
      :value="checkAll" @click.prevent.native="selectAllOrCanelAll">年份</i-checkbox>
    <i-checkbox-group v-model="yearsFilter" @on-change="checkGroupChanged">
      <i-checkbox
        v-for="year in years"
        :key="year" :label="year" />
    </i-checkbox-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'YearFilter',
  props: {
    years: { type: Array, required: true },
  },
  data() {
    return {
      indeterminate: false,
      checkAll: false,
      yearsFilter: [],
    };
  },
  computed: {
    yearsFilterStore() {
      return this.$store.state.libraryStore.filters.years;
    },
  },
  watch: {
    yearsFilter(years) {
      this.setYearsFilter({ years });
    },
    yearsFilterStore(years) {
      this.yearsFilter = years;

      if (years.length === 0) {
        this.checkAll = false;
        this.indeterminate = false;
      }
    },
  },
  methods: {
    ...mapActions({
      setYearsFilter: 'libraryStore/invokeSetYearsFilter',
    }),
    /**
     * 年份筛选全选与取消全选
     */
    selectAllOrCanelAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      this.yearsFilter = [];
      if (this.checkAll) {
        this.years.forEach((year, index) => {
          this.$set(this.yearsFilter, index, year);
        });
      }
    },
    /**
     * 复选框组变化
     */
    checkGroupChanged(data) {
      if (data.length === this.years.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.year-filter {
  width: 100%;

  > .title {
    margin-bottom: 12px;
    font-size: 13px;

    /deep/ .ivu-checkbox {
      margin-right: 6px;
    }
  }

  /deep/ .ivu-checkbox-group {
    padding-left: 26px;

    .ivu-checkbox-group-item {
      font-size: 13px;

      .ivu-checkbox {
        margin-right: 6px;
      }
    }
  }
}
</style>
